import { useState, useEffect } from 'react';

const useDebounce = (value, delay, onlyLast = false, withFunc = false) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [lastValue, setLastValue] = useState(null);

  useEffect(() => {
    onlyLast && setLastValue(value);

    const handler = setTimeout(() => {
      if (onlyLast && value === lastValue) {
        setDebouncedValue(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, lastValue, onlyLast]);

  return debouncedValue;
};

export { useDebounce };
